import fm from 'format-message';
import PropTypes from 'prop-types';
import Link from '@activebrands/core-web/components/Link';
import ScrollableBox from '@activebrands/core-web/components/ScrollableBox';
import BreadcrumbsStructuredData from '@activebrands/core-web/components/seo-meta/structured-data/BreadcrumbsStructuredData';
import { styled } from '@activebrands/core-web/libs/styletron';
import { getFocusRingStyles } from '@activebrands/core-web/utils/style-functions/get-focus-styles';

const List = styled('ul', {
    display: 'flex',
    whiteSpace: 'nowrap',
});

const Item = styled('li', {
    color: 'var(--color-text-breadcrumbs-color-default)',

    ':last-of-type': {
        paddingRight: 'var(--padding-content-breadcrumbs)',
        color: 'var(--color-text-breadcrumbs-color-active)',
    },

    ':not(:last-of-type)::after': {
        content: '"/"',
        margin: '0px 4px',
    },
});

const ItemLink = styled(Link, {
    color: 'inherit',
    ...getFocusRingStyles(),
});

/**
 * @param {object} props
 * @param {object} [props.$style]
 * @param {boolean} [props.addStructuredData]
 * @param {Array<{ label?: string, to?: string }>} [props.items]
 * @param {object} [props.listStyles]
 * @param {object} [props.linkStyle]
 * @param {string} [props.selector]
 */
const Breadcrumbs = ({
    $style = {},
    addStructuredData = true,
    items = [],
    listStyles = {},
    linkStyle = {},
    selector,
}) => {
    if (!items?.length) {
        return null;
    }

    return (
        <>
            {addStructuredData && <BreadcrumbsStructuredData items={items} />}
            <ScrollableBox $style={$style} data-selector={selector} scrolldirection="horizontal">
                <List $style={listStyles}>
                    <Item $style={linkStyle}>
                        <ItemLink to="/">{fm('Home')}</ItemLink>
                    </Item>
                    {items.map(item => (
                        <Item $style={linkStyle} key={item.label}>
                            {item.to ? <ItemLink to={item.to}>{item.label}</ItemLink> : item.label}
                        </Item>
                    ))}
                </List>
            </ScrollableBox>
        </>
    );
};

Breadcrumbs.propTypes = {
    $style: PropTypes.object,
    addStructuredData: PropTypes.bool,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            to: PropTypes.string,
        })
    ),
    linkStyle: PropTypes.object,
    listStyles: PropTypes.object,
    selector: PropTypes.string,
};

export default Breadcrumbs;
